import { useEffect, useState } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import { Box, Button, Grid, Typography, TextField, Select, MenuItem, Autocomplete, CircularProgress, Checkbox, FormControl } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';
import { gridSpacing } from 'app/constant';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import StickyHeadTable from './components/StickyHeadTable';
import { warningAlert, successAlert, errorAlert } from 'ui-component/Toasts';
import useFetchData from 'hooks/useFetchData';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

const Payment = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();

    console.log(token);

    const [payment, setPayment] = useState([]);
    const [filterPaymentFrom, setFilterPaymentFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterPaymentTo, setFilterPaymentTo] = useState(dayjs());
    const [filterCustomerLoginUserName, setFilterCustomerLoginUserName] = useState('');
    const [filterStatusList, setFilterStatusList] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const fetchPayment = async () => {
        if (!filterPaymentFrom.isValid() || !filterPaymentTo.isValid()) {
            warningAlert('Please fill up all required fields.');
            return;
        }
        let fetchPaymentURL = `/Payment/All?createdDateFrom=${filterPaymentFrom.format(
            'YYYY-MM-DD'
        )}&createdDateTo=${filterPaymentTo.format('YYYY-MM-DD')}`;
        
        if (filterCustomerLoginUserName !== '') {
            fetchPaymentURL += `&loginUserName=${filterCustomerLoginUserName}`;
        }
        if (filterStatusList !== '') {
            fetchPaymentURL += `&statusID=${filterStatusList}`;
        }
        setLoading(true);
        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(fetchPaymentURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setPayment(res.data);
                console.log(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
            setFilterBtnDisabled(false);
        }
    };

    const { data: loginUsernameOptions } = useFetchData('/Customer/LoginUserNames');
    const { data: StatusList } = useFetchData('/PaymentStatus/All');
    const { data: thirdparty } = useFetchData('/ThirdParty');

    return (
        <Grid container spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
            <Grid item xs={12} md={6} lg={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Typography sx={{ fontSize: '16px', whiteSpace: 'nowrap' }}>
                        <span style={{ color: 'red' }}>*</span>From :
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={filterPaymentFrom}
                            slotProps={{
                                textField: {
                                    error: false
                                }
                            }}
                            onChange={(newValue) => setFilterPaymentFrom(newValue)}
                        />
                    </LocalizationProvider>
                </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Typography sx={{ fontSize: '16px', whiteSpace: 'nowrap' }}>
                        <span style={{ color: 'red' }}>*</span>To :
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={filterPaymentTo}
                            slotProps={{
                                textField: {
                                    error: false
                                }
                            }}
                            onChange={(newValue) => setFilterPaymentTo(newValue)}
                        />
                    </LocalizationProvider>
                </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Typography sx={{ fontSize: '16px', whiteSpace: 'nowrap' }}>
                        Login Username :
                    </Typography>
                    <Autocomplete
                            freeSolo
                            value={filterCustomerLoginUserName}
                            onChange={(event, newValue) => {
                                setFilterCustomerLoginUserName(newValue);
                            }}
                            inputValue={filterCustomerLoginUserName}
                            onInputChange={(event, newInputValue) => {
                                setFilterCustomerLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={loginUsernameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                </Box>
            </Grid>

            <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Status :
                        </Typography>
                        <FormControl fullWidth>
                            <Select
                                displayEmpty
                                value={filterStatusList}
                                onChange={(e) => setFilterStatusList(e.target.value)}
                                // sx={{width:"100%"}}
                            >
                                <MenuItem value="">Select Status</MenuItem>
                                {StatusList.map((item, index) => (
                                    <MenuItem value={item.id} key={index}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
            <Grid item xs={12} container justifyContent="center">
                <Button
                    variant="contained"
                    sx={{
                        float: 'right',
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '30px'
                    }}
                    onClick={() => fetchPayment()}
                    disabled={filterBtnDisabled}
                >
                    Filter
                </Button>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable payment={payment} fetchPayment={fetchPayment} statusList={StatusList} thirdPartyList={thirdparty}/>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default Payment;
